import React from "react";
import { splitMoney } from "@/lib/format";
import { cn } from "@/lib/utils";

/**
 * Todo monto se muestra en monoespaciada: la parte entera en tinta
 * plena y los centavos en tamaño reducido y tinta secundaria, alineado
 * a la derecha. Usar en cualquier lugar donde antes se llamaba a
 * formatMoney() directamente en un nodo visible.
 */
export const Amount = ({ cents, className, testId }) => {
  const { sign, whole, frac } = splitMoney(cents);
  return (
    <span data-testid={testId} className={cn("whitespace-nowrap font-mono tabular-nums text-ink", className)}>
      {sign}${whole}
      <span className="text-[0.8em] text-ink-secondary">.{frac}</span>
    </span>
  );
};

/**
 * Códigos legibles (WO-2026-0411): el prefijo en tinta terciaria, el
 * número final en tinta plena. Se escanea mejor y se ve deliberado.
 */
export const WoCode = ({ code, className, testId }) => {
  if (!code) return <span className={cn("font-mono text-ink-tertiary", className)}>—</span>;
  const idx = code.lastIndexOf("-");
  const prefix = idx >= 0 ? code.slice(0, idx + 1) : "";
  const num = idx >= 0 ? code.slice(idx + 1) : code;
  return (
    <span data-testid={testId} className={cn("whitespace-nowrap font-mono tabular-nums", className)}>
      <span className="text-ink-tertiary">{prefix}</span>
      <span className="text-ink">{num}</span>
    </span>
  );
};
